function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from 'react';
import { ComponentBootstrap } from '@demant/react-bootstrap';
import { Container, Modal, Button, Form, Row, Col, Spinner } from 'react-bootstrap';
import richTextSchema from '@demant/react-bootstrap/lib/schemas/rich-text';
// import 'bootstrap/dist/css/bootstrap.min.css' loaded in sitecore PageTagSettings
import PropTypes from 'prop-types';
import axios from 'axios';
var RichTextModal = function RichTextModal(_ref) {
  var settings = _ref.settings,
    component = _ref.component;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    validated = _useState2[0],
    setValidated = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    loading = _useState4[0],
    setLoading = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    cseaEligible = _useState6[0],
    setCseaEligible = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    cseaError = _useState8[0],
    setCseaError = _useState8[1];
  var _useState9 = useState(true),
    _useState0 = _slicedToArray(_useState9, 2),
    show = _useState0[0],
    setShow = _useState0[1];
  var handleClose = function handleClose() {
    return setShow(false);
  };
  var handleSubmit = function handleSubmit(event) {
    var form = event.currentTarget;
    var formData = new FormData(form);
    event.preventDefault();
    event.stopPropagation();
    if (form.checkValidity() === false) {
      setValidated(true);
    }

    // test id 1232259983
    if (form.checkValidity() === true) {
      setLoading(true);
      axios({
        method: 'post',
        url: 'https://www.cseany.org/verifyEligibility.php',
        data: formData
      }).then(function (res) {
        // console.log('RESPONSE RECEIVED: ', res);
        if (res.data.EligibilityResponse.EligibilityData.eligible === 'Y') {
          setCseaEligible(true);
          handleClose();
        }
        if (res.data.EligibilityResponse.EligibilityData.eligible === 'N') {
          form.reset();
          setCseaEligible(false);
          setCseaError(true);
        }
        setLoading(false);
      }).catch(function (err) {
        console.log('AXIOS ERROR: ', err);
      });
    }
  };
  return /*#__PURE__*/React.createElement(Modal, {
    show: show,
    onHide: handleClose,
    backdrop: "static",
    keyboard: false
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    className: "yh-bgcolor--blue"
  }, /*#__PURE__*/React.createElement(Modal.Title, null, "Verify CSEA Enrollment")), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "justify-content-center"
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Col, null, settings.content.html)), /*#__PURE__*/React.createElement(Row, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Form, {
    noValidate: true,
    validated: validated,
    onSubmit: handleSubmit
  }, /*#__PURE__*/React.createElement(Form.Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: "auto"
  }, /*#__PURE__*/React.createElement(Form.Label, {
    htmlFor: "UID",
    srOnly: true
  }, "CSEA ID Number"), /*#__PURE__*/React.createElement(Form.Group, {
    controlId: "formCseaId"
  }, /*#__PURE__*/React.createElement(Form.Control, {
    name: "UID",
    type: "text",
    placeholder: "ex. 1234567890",
    maxLength: "10",
    minLength: "10",
    required: true
  }), /*#__PURE__*/React.createElement(Form.Control.Feedback, {
    type: "invalid"
  }, cseaError ? 'CSEA ID not found. Please try again' : 'Please enter your CSEA ID'), cseaEligible && /*#__PURE__*/React.createElement(Form.Control.Feedback, {
    type: "valid"
  }, "CSEA ID Verified!"))), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    type: "submit"
  }, loading ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spinner, {
    as: "span",
    animation: "border",
    size: "sm",
    role: "status",
    "aria-hidden": "true"
  }), ' ', "Verifying...") : /*#__PURE__*/React.createElement("span", null, "Submit")))))))));
};
RichTextModal.propTypes = {
  settings: PropTypes.shape({
    content: PropTypes.shape({
      html: PropTypes.objectOf(PropTypes.any)
    })
  }).isRequired,
  component: PropTypes.objectOf(PropTypes.any)
};
var myComponent = new ComponentBootstrap('.csea-modal');
myComponent.schemaData = richTextSchema;
myComponent.reactApp = RichTextModal;
myComponent.run();